import { z } from "zod";

export const listPreferencesSchema = z.object({
    density: z.enum(["comfortable", "compact"]),
    hidden: z.array(z.string()).max(50),
});
export type ListPreferences = z.infer<typeof listPreferencesSchema>;
export const listSortSchema = z.object({
    key: z.string(),
    order: z.enum(["asc", "desc"]),
});
export const listViewSchema = z.object({
    search: z.string().max(500),
    filters: z.record(z.string(), z.string()).default({}),
    sort: listSortSchema,
    preferences: listPreferencesSchema,
    pageSize: z.number().int().min(1).max(100).default(20),
    context: z.string().default(""),
});
export type ListView = z.infer<typeof listViewSchema>;
export const parseListSelection = (value?: string): string[] => {
    try {
        const parsed = z
            .array(z.string())
            .max(500)
            .safeParse(JSON.parse(value || "[]"));
        return parsed.success ? parsed.data : [];
    } catch {
        return [];
    }
};
